<template>
    <div :class="{ 'status-component': statusComponent }">
        <div v-if="showDescription" class="support-text mb-4">
            {{ translate('support.description') }}
        </div>

        <ServiceNotification v-if="showNotifications" class="pb-3" :notifications="notifications" />

        <UIGridRow>
            <UIGridCol cols="12" :md="columnWidth" class="mb-0 mb-md-3">
                <div class="service-link mb-3" :class="{ horizontal: horizontal }" @click="showContactForm()">
                    <div class="icon">
                        <UIIcon name="envelope"></UIIcon>
                    </div>
                    <div class="content-text">
                        <h6>{{ !statusComponent ? translate('support.serviceLink.mail') : 'support@dundle.com' }}</h6>
                        <p v-if="!statusComponent" class="small">{{ translate('support.serviceLink.mailDesc') }}</p>
                    </div>
                </div>
            </UIGridCol>
        </UIGridRow>
    </div>
</template>

<script>
import { UIGridRow, UIGridCol, UIIcon } from '@dundle/ui/components';
import { mapActions } from 'vuex';
import ServiceNotification from './ServiceNotification';
import TranslationMixin from '~/mixins/TranslationMixin';

export default {
    components: {
        UIGridRow,
        UIGridCol,
        ServiceNotification,
        UIIcon,
    },
    mixins: [TranslationMixin],
    props: {
        showNotifications: {
            type: Boolean,
            default: true,
        },

        showDescription: {
            type: Boolean,
            default: true,
        },

        statusComponent: {
            type: Boolean,
            default: false,
        },
        fullWidth: {
            type: Boolean,
            default: false,
        },
        horizontal: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            notifications: [],
        };
    },

    computed: {
        columnWidth() {
            if (this.fullWidth && this.horizontal) {
                return 4;
            } else if (this.fullWidth) {
                return 12;
            } else {
                return 6;
            }
        },
    },

    mounted() {
        if (this.showNotifications) this.getNotifications();
    },

    methods: {
        ...mapActions({
            hideModal: 'ui/hideModal',
        }),

        closeModal() {
            this.hideModal();
        },

        navigateToFacebook() {
            this.$redirect.toFacebookMessenger();
        },

        navigateToTwitter() {
            window.open('https://twitter.com/messages/compose?recipient_id=1121771806011138049');
        },

        showContactForm() {
            this.closeModal();
            if (this.statusComponent) {
                window.open(this.$locale.path('service-contact'), '_blank');
            } else {
                this.$router.push(this.$locale.path('service-contact'));
            }
        },

        async getNotifications() {
            this.notifications = await this.$api.notifications.getNotifications();
        },
    },
};
</script>

<style lang="scss" scoped>
.service-link {
    display: flex;
    flex-direction: row;
    align-items: center;
    background: $color-bg;
    border-radius: $border-radius-default;
    cursor: pointer;
    padding: 0.8rem 0;
    user-select: none;
    box-shadow: 0px 0px 0px 1px $color-grey-3;

    @media only screen and (min-width: 768px) {
        margin-bottom: 0 !important;
    }

    .content-text {
        text-align: left;
    }

    .icon {
        display: flex;
        justify-content: center;
        color: $color-primary;
        margin: 0 1rem;

        svg {
            width: 1.8rem;
            height: 1.8rem;
        }
    }

    h6 {
        color: $color-text-bold;
        font-weight: 600;
        margin-bottom: 0;
    }

    p {
        margin: 0;
        color: $color-grey-5;
        padding: 0;
    }

    &.disabled {
        &:active {
            background: $color-grey-2;
            box-shadow: inset 0 0 7px 0 rgba(0, 0, 0, 0.1);
            user-select: none;
        }
        &:hover {
            cursor: no-drop;
            &:after {
                opacity: 0;
            }
        }
        .icon {
            color: $color-grey-2;
        }
    }

    &:hover {
        box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.4);
        cursor: pointer;
        text-decoration: none;

        &.disabled {
            color: $color-grey-4;
            box-shadow: 0px 0px 0px 1px rgba(204, 204, 204, 1);
        }
        &.active {
            box-shadow: inset 0 0 4px 0 rgba(116, 70, 70, 0.5), 0px 0px 0px 1px $color-primary;
            cursor: default;
            color: white;
        }

        @media screen and (min-width: 1024px) {
            &:after {
                opacity: 1;
            }
        }
    }

    &:active {
        background: $color-primary;
        box-shadow: inset 0 0 7px 0 rgba(0, 0, 0, 0.3);

        .icon {
            color: $color-text-inverted;
        }

        h6,
        p {
            color: $color-text-inverted;
        }

        &:after {
            opacity: 0 !important;
        }
    }

    &.horizontal {
        flex-direction: column;
        display: flex;
        justify-content: center;

        @media only screen and (min-width: 768px) {
            height: 9rem;
        }

        .content-text {
            margin-top: 0.7rem;
            padding: 0 12px;
            text-align: center;
        }
    }
}
</style>
<i18n src="@dundle/locale/data/support.json"></i18n>
